export const TOUR_NEXT_COPY = 'Next'
export const TOUR_DONE_COPY = 'Done'
